import { Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { FeatureAuthForm } from 'system/components/feature-auth/form';
import { CommonFeatureAuthCrumbs } from 'system/constants/common-feature-auth-crumbs';
import { HttpResponse } from 'shell/models/http-response';
import { FeatureAuth } from 'shell/models/feature-auth';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformFeatureAuth } from 'system/components/feature-auth/utils/transform-feature-auth';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const FeatureAuthDetail = (): React.ReactElement => {
  const params = useParams();

  const updateFeatureAuth = useHttpClient(
    `${__MANAGEMENT_API_URL__}/tipo-feature-auth/${params.id}`,
    {
      options: {
        errorCatching: true,
        method: 'PUT',
        loading: true,
        data: {},
      },
    }
  );

  const [featureAuth] = useHttpFetch<HttpResponse<FeatureAuth>, FeatureAuthForm>(
    `${__MANAGEMENT_API_URL__}/tipo-feature-auth/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformFeatureAuth,
    }
  );

  const navigate = useNavigate();

  const onOk = (form: FeatureAuthForm | undefined) => {
    (
      updateFeatureAuth({
        data: {
          descrizioneTipoFeature: form?.description || undefined,
          key: {
            codiceFeature: Number.parseInt(form?.code || '', 10),
          },
          note: form?.contextLastUpdate || undefined,
          featureValoreList: form?.valuesFeatureAuth?.body.map((item) => {
            return {
              key: {
                codiceFeature: Number.parseInt(form?.code || '', 0),
                valoreAmmesso: item.value || undefined,
              },
              descrizioneValoreAmmesso: item.description || undefined,
            };
          }),
        },
      }) as ResponsePromise<void, void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/feature-auth');
    });
  };

  const loading = featureAuth.isLoading || featureAuth.pristine || featureAuth.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonFeatureAuthCrumbs, { name: 'Modifica Autorizzazione' }]} />
      {loading ? null : (
        <Form
          title="Modifica Autorizzazione"
          onOk={onOk}
          initialValues={featureAuth.data as FeatureAuthForm}
          onCancel={() => {
            navigate('/sistema/feature-auth');
          }}
          isEdit
          redirectPath={`feature-auth/modifica/${
            (featureAuth.data as FeatureAuthForm)?.code || ''
          }`}
        />
      )}
    </Fragment>
  );
};

FeatureAuthDetail.displayName = 'Feature Auth Edit page component';

export default FeatureAuthDetail;
